import React, { useState } from "react";

const PageSidebar = ({ pages, activePageId, onSelectPage, onAddPage, onDeletePage, onReorderPages }) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => setDraggedIndex(index);
  const handleDragOver = (e) => e.preventDefault();
  const handleDrop = (index) => {
    if (draggedIndex === null || draggedIndex === index) return;
    onReorderPages(draggedIndex, index);
    setDraggedIndex(null);
  };

  return (
    <div
      style={{
        width: "100%",
        flexShrink: 0,
        background: "var(--bg-panel)",
        border: "1px solid var(--border-color)",
        borderRadius: 12,
        display: "flex",
        flexDirection: "column",
        padding: 15,
      }}
    >
      <h3 style={{ fontSize: 16, borderBottom: "1px solid #333", paddingBottom: 10, marginBottom: 15, color: "#fff", flexShrink: 0 }}>
        頁面管理
      </h3>
      
      {/* 列表區域（外層滾動由左欄容器負責） */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10, paddingRight: 5 }}>
        {pages.map((page, index) => {
          const isActive = activePageId === page.id;
          return (
            <div
              key={page.id}
              draggable
              onDragStart={() => handleDragStart(index)}
              onDragOver={handleDragOver}
              onDrop={() => handleDrop(index)}
              onClick={() => onSelectPage(page.id)}
              style={{
                position: "relative",
                padding: 10,
                border: isActive ? "1px solid var(--accent-color)" : "1px solid #333",
                borderRadius: 8,
                background: isActive ? "rgba(59, 130, 246, 0.1)" : "#252525",
                cursor: "pointer",
                opacity: draggedIndex === index ? 0.5 : 1,
                transition: "all 0.2s",
                flexShrink: 0 // 防止被壓縮
              }}
            >
              <div style={{ fontSize: 13, fontWeight: "bold", marginBottom: 6, color: isActive ? "#fff" : "#aaa" }}>
                第 {index + 1} 頁
              </div>

              <div
                style={{
                  width: "100%",
                  height: 90,
                  background: "#121212",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 11,
                  color: "#555",
                  overflow: "hidden",
                  borderRadius: 4
                }}
              >
                {page.imageSrc ? (
                  <img src={page.imageSrc} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  <span>無圖片</span>
                )}
              </div>

              {pages.length > 1 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeletePage(page.id);
                  }}
                  style={{
                    position: "absolute", top: -5, right: -5,
                    background: "var(--danger-color)", color: "#fff",
                    border: "2px solid var(--bg-panel)", borderRadius: "50%",
                    width: 22, height: 22, fontSize: 12,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* 底部按鈕：固定不動 */}
      <button
        onClick={onAddPage}
        style={{
          marginTop: 15,
          background: "#333",
          border: "1px dashed #555",
          color: "#aaa",
          padding: "12px",
          borderRadius: 6,
          cursor: "pointer",
          width: "100%",
          fontSize: 13,
          flexShrink: 0 // 防止被壓縮
        }}
        onMouseOver={(e) => { e.target.style.background = "#444"; e.target.style.color = "#fff"; }}
        onMouseOut={(e) => { e.target.style.background = "#333"; e.target.style.color = "#aaa"; }}
      >
        + 新增頁面
      </button>
    </div>
  );
};

export default PageSidebar;